// extracted by mini-css-extract-plugin
module.exports = {"house-video":"HouseVideo_house-video__FwnR8","house-video-section":"HouseVideo_house-video-section__DRE_b"};